///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/viewmodels/context/events"/>
import { EventAggregator } from "Core/Medius.Core.Web/Scripts/Medius/lib/events";
const CONTEXT_EVENTS_KEY = "viewmodel-context-events";

export = function eventsDecorator(context:any) {
    context.events = context.ensure(CONTEXT_EVENTS_KEY, new EventAggregator());
    context.disposal.register(context.events.dispose.bind(context.events));
};